import { Link } from "react-router-dom";
import { categoryShortcuts } from "@/mocks/home";

const accentMap = {
  primary: {
    icon: "bg-primary-100 text-primary-700",
    link: "hover:border-primary-400 hover:text-primary-700",
    bar: "bg-primary-500",
  },
  accent: {
    icon: "bg-accent-100 text-accent-900",
    link: "hover:border-accent-400 hover:text-accent-900",
    bar: "bg-accent-500",
  },
  secondary: {
    icon: "bg-secondary-100 text-secondary-800",
    link: "hover:border-secondary-400 hover:text-secondary-900",
    bar: "bg-secondary-500",
  },
} as const;

export default function QuickCategory() {
  return (
    <div className="grid gap-4 md:grid-cols-3">
      {categoryShortcuts.map((group) => {
        const accent = accentMap[group.accent as keyof typeof accentMap];
        return (
          <div
            key={group.title}
            className="relative flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 p-5"
          >
            <span className={`absolute inset-x-0 top-0 h-[3px] ${accent.bar}`}></span>
            <div className="flex items-center gap-3">
              <span className={`flex h-10 w-10 items-center justify-center rounded-md ${accent.icon}`}>
                <i className={`${group.icon} text-lg`} aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950">{group.title}</h3>
                <p className="font-label text-[11px] text-foreground-500">{group.subtitle}</p>
              </div>
            </div>
            <div className="mt-4 flex flex-wrap gap-2">
              {group.options.map((option) => (
                <Link
                  key={option.href}
                  to={option.href}
                  className={`inline-flex items-center gap-1 rounded-md border border-background-300 px-2.5 py-1.5 font-label text-xs text-foreground-700 transition-colors ${accent.link}`}
                >
                  {option.label}
                  <i className="ri-arrow-right-up-line text-[11px]" aria-hidden="true"></i>
                </Link>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}